// extracted by mini-css-extract-plugin
export default {"body":"deleteUserRequestModal_body__DOUnw"};